var map = {
	"./appointment.png": 79038,
	"./appointment_black.png": 79232,
	"./assessment.png": 99142,
	"./assessment_black.png": 72094,
	"./consulting.png": 74791,
	"./consulting_black.png": 33723,
	"./examRequest.png": 14913,
	"./examRequest_black.png": 30934,
	"./exercise.png": 82596,
	"./exercise_black.png": 22174,
	"./medicalNote.png": 16976,
	"./medicalNote_black.png": 58764,
	"./medicalTreatment.png": 19671,
	"./medicalTreatment_black.png": 52755,
	"./race.png": 5138,
	"./race_black.png": 92960,
	"./rehabilitation.png": 85907,
	"./rehabilitation_black.png": 97587,
	"./rest.png": 39575,
	"./rest_black.png": 42766,
	"./training.png": 6428,
	"./training_black.png": 15761,
	"./treatment.png": 18206,
	"./treatment_black.png": 72700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43860;